import React, { useMemo, useState } from 'react'
import { FaEnvelope, FaPhone } from "react-icons/fa"
import { Form, InputGroup } from "react-bootstrap"
import { Formatter } from 'gf-ui'
import { validateEmail } from '../pages'

const Telefono = ({telefono, onChangeTelefono, email, onChangeEmail, privacy, onChangePrivacy}) => {  
  const telefonoValido = useMemo(()=>telefono.length >= 8, [telefono.length])
  const telefonoNonValido = useMemo(()=>telefono.length > 0 && telefono.length < 8, [telefono.length])

  const [emailValida, setEmailValida] = useState(false)
  const [emailNonValida, setEmailNonValida] = useState(false)  

  const _onChangeEmail = (e) => {
    const value = e.target.value
    const isValida = validateEmail(value)
    setEmailValida(isValida)
    setEmailNonValida(!Formatter.isStringaVuota(value) && !isValida)
    onChangeEmail(value)
  }

  const urlPrivacy = useMemo(()=>{
    switch(process.env.REACT_APP_ENV_NAME){
      case 'osgtest':
        return 'https://www.hsangiovanni.roma.it/documenti/file-pdf/cookie_policy_san_giovanni.pdf'        
      case 'ptv':
      case 'ptvtest':
        return '/questionari/aagg-p-mod-inf1.pdf'              
      case 'rm1':
      case 'rm1test':
        return 'https://www.aslroma1.it/uploads/files/47_48_Facsimile-Informativa_privacy_Ue_2016-679.pdf'                    
      default:
        return '/'        
    }  
  }, [])

  return (
    <div className='border rounded p-4'>
      <Form.Group>
        <Form.Label className="mt-4" style={{fontSize: 24}}>Inserisci il tuo numero di telefono per eventuali comunicazioni</Form.Label>                                        
        <InputGroup className={`mb-3 ${telefonoValido ? "is-valid" : telefonoNonValido ? "is-invalid" : ""}`}>
          <InputGroup.Text id="basic-addon1"><FaPhone /> </InputGroup.Text>
          <Form.Control type="tel"
                        aria-label="Telefono"
                        style={{fontSize: '1.5em'}} 
                        onChange={(e) => isNaN(e.target.value) ? null : onChangeTelefono(e.target.value)} 
                        value={telefono}                         
                        className={`form-control ${telefonoValido ? "is-valid" : telefonoNonValido ? "is-invalid" : ""}`}
                        placeholder="Telefono"
                        required
                        />                                
        </InputGroup>      
      </Form.Group>      
      
      <Form.Group>
        <Form.Label className="mt-4" style={{fontSize: 24}}>Inserire indirizzo e-mail per eventuali comunicazioni (facoltativo)</Form.Label>                                        
        <InputGroup className={`mb-3 ${emailValida ? "is-valid" : emailNonValida ? "is-invalid" : ""}`}>
          <InputGroup.Text id="basic-addon1"><FaEnvelope /> </InputGroup.Text>
          <Form.Control type="email"
                        aria-label="Email"
                        style={{fontSize: '1.5em'}} 
                        onChange={_onChangeEmail} 
                        value={email}                         
                        className={`form-control ${emailValida ? "is-valid" : emailNonValida ? "is-invalid" : ""}`}
                        placeholder="Email"                        
                        />                                
        </InputGroup>      
      </Form.Group>

      <Form.Group className='mt-4'>
        <Form.Check
          disabled={false}
          type="checkbox"
          label={<h5 className='ms-2'>Ho letto e compreso l'informativa sulla privacy</h5>}
          id="privacy-check"
          className={`${(telefono.length >= 9 && !privacy)?'text-danger':'text-dark'}`}
          checked={privacy}                                
          onChange={(e)=>onChangePrivacy(e.target.checked)}
          required
        />
          <a href={urlPrivacy} target="_blank" rel="noreferrer" className="">Informativa privacy</a>                  
      </Form.Group>
    </div>
  )
}

export default Telefono;